export const DeepLinkRedirectStorageKey = {
  ptVouchers: 'pt_deep_link_redirect_to_app_store',
  onDemand: 'on_demand_deep_link_redirect_to_app_store',
  liveStream: 'live_stream_deep_link_redirect_to_app_store',
  extras: 'extras_deep_link_redirect_to_app_store',
} as const;
